import React, {
  useState,
  useRef,
  forwardRef,
  useContext,
  useLayoutEffect,
  useCallback,
} from 'react';

import cx from 'classnames';

import { POIVenuesContext } from 'modules/point-of-interest';

const POIVenueItem = forwardRef(({ venue, venueId, selected, onClick }, ref) => {
  const handleVenueClick = useCallback(() => {
    onClick(venueId);
  }, [onClick, venueId]);

  return (
    <div
      className={cx('venue-item', {
        selected,
      })}
      ref={ref}
      onClick={handleVenueClick}
      data-testid="POIVenuesList__item"
    >
      <div className="venue-name">{venue?.properties?.name}</div>
      <div className="venue-address">
        {venue?.placeAggregatedInfo?.street} {venue?.placeAggregatedInfo?.housenumber}{' '}
        {venue?.placeAggregatedInfo?.postalcode}
      </div>
    </div>
  );
});

const POIVenuesList = ({ className }) => {
  const [selectedOverClick, setSelectedOverClick] = useState(null);
  const { venues, selectVenue, selectedVenue } = useContext(POIVenuesContext);

  const selectedRef = useRef(null);

  const handleVenueClick = useCallback(
    (venueId) => {
      setSelectedOverClick(venueId);
      selectVenue(venueId);
    },
    [selectVenue]
  );

  useLayoutEffect(() => {
    if (!selectedVenue || !selectedRef.current) {
      return;
    }

    if (selectedOverClick === selectedVenue) {
      return;
    }

    if (!selectedRef.current.scrollIntoView) {
      return;
    }

    selectedRef.current.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
      inline: 'start',
    });
  }, [selectedVenue, selectedOverClick]);

  if (!venues || !venues.size) {
    return null;
  }

  return (
    <div className={className} data-testid="POIVenuesList">
      {Array.from(venues.keys()).map((id) => (
        <POIVenueItem
          key={id}
          venue={venues.get(id)}
          selected={id === selectedVenue}
          ref={id === selectedVenue ? selectedRef : null}
          onClick={handleVenueClick}
          venueId={id}
        />
      ))}
    </div>
  );
};

export default POIVenuesList;
